import type { FuelUser } from '../../models/user';

export const enhanceFetchedUser = (item: FuelUser, ouId: string, isSuperAdmin: boolean = false) => {
  // console.log('processUser', { item });
  const actions = [
    {
      title: 'Edit',
      className: !item.parentOuUser ? 'action' : 'action disabled-icon',
      type: 'edit',
      iconClass: 'icon material-icons',
      iconName: 'mode_edit',
      isDisabled: false,
    },
    {
      title: 'Delete',
      className: !item.parentOuUser ? 'action' : 'action disabled-icon',
      type: 'delete',
      iconClass: 'icon material-icons',
      iconName: 'delete',
      isDisabled: false,
    },
  ];
  item.name = `${item.userInfo.firstName} ${item.userInfo.lastName}`;
  item.roles = getOUROles(item, ouId);
  item.rolesString = item.roles.join(', ');
  if (item.ouAccessRights && item.ouAccessRights[ouId]) {
    item.enabled = item.ouAccessRights[ouId].enabled;
  }
  item.actions = actions;
  item.enableMFA = item.userInfo.enableMFA;
  return item;
};

const getOUROles = (item: FuelUser, ouId: string) => {
  // console.log('getOUROles', { item, ouId });
  if (ouId) {
    const foundOU = item.ouAccessRights[ouId];
    if (foundOU && foundOU.roles && foundOU.roles.length > 0) {
      return foundOU.roles;
    }
  }
  return [];
};
